import { TELLY, planName, termLabel } from '@/shared/pricing';
import { A } from '@/shared/locales/account/keys';

/** "Demon · 1 Year · 2 connections" in the visitor's language. `t` comes from useT(). */
export function planSummaryT(order, t) {
  if (!order) return '';
  const n = Number(order.connections_c || 1);
  if (order.plan_c === 'Telly') return `${TELLY.name} · ${t('{count} licences', { count: n })}`;
  if (order.plan_c === 'Product') return `${order.product_c?.Name ?? 'Product'} · ${t(termLabel('Product', order.term_c))}`;
  return `${planName(order.plan_c)} · ${t(termLabel(order.plan_c, order.term_c))} · ${t('{count} connections', { count: n })}`;
}

/** "3 days left", "5 hours left", "Ended" in the visitor's language, or null with no end date. */
export function timeLeftT(endsAt, t, now = Date.now()) {
  if (!endsAt) return null;
  const ms = new Date(endsAt).getTime() - now;
  if (ms <= 0) return t(A.ended);
  const h = ms / 3600000;
  if (h < 1) return t(A.minLeft, { count: Math.max(1, Math.round(ms / 60000)) });
  if (h < 48) return t(A.hoursLeft, { count: Math.round(h) });
  return t(A.daysLeft, { count: Math.round(h / 24) });
}
